import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { CoreMenuItem } from 'app/back-office/shared/models/core';
import { FeatherIconDirective } from 'app/back-office/shared/directives/feather-icon/feather-icon.directive';

@Component({
    selector: '[core-menu-vertical-item]',
    imports: [NgClass, NgTemplateOutlet, RouterModule, TranslateModule, FeatherIconDirective],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './item.component.html'
})
export class CoreMenuVerticalItemComponent {
  item = input.required<CoreMenuItem>();
}
